// Dashboard (Home) screen help (the "?" at the top right of the Dashboard). Plain words; keep it
// in step with the screen (apps/mobile/src/v10/DashboardView.tsx).
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const dashboardHelp: ScreenHelpContent = {
  title: 'Dashboard',
  intro:
    "The Dashboard is your one-glance view of how things stand. It doesn't change anything by itself. Every card is a door: tap it to go to the screen that owns it.",
  sections: [
    {
      heading: 'The cards',
      items: [
        { term: 'NOW', text: 'your current Step. Tap "Do it" to open the tool for it, or tap the card to see it in the orb. If it says there is no step waiting, pick one on the compass.' },
        { term: 'TODAY', text: 'what is on your agenda. The ‹ › arrows switch between TODAY, WEEK (the next 7 days) and MONTH (the next 30 days). Tap the card to open METIS for today, or KRNOS for the week and month. It shows the first 6 items and counts the rest.' },
        { term: 'SHAPE', text: 'one dial for each of your five life areas. Tap a dial to open that area.' },
        { term: 'PANTHEON', text: 'how many deities you have acquired. Tap the card to open the Pantheon.' },
        { term: 'NUMA', text: 'your energy: FLOW, LOAD and CHARGE. Tap the card to open NUMA.' },
      ],
    },
    {
      heading: 'Reading a SHAPE dial',
      body: [
        'The number in the middle is the Alignment Score, from 0 to 4. It asks two things: are you doing the right work, and are you keeping up with what is due? A dash means that area is not set up yet.',
        'Under the dial is a word and how much of that area is complete. The score looks back over the number of days shown at the top of the card.',
      ],
      items: [
        { term: 'Aligned', text: 'green. You are on track.' },
        { term: 'Mostly', text: 'light green. Nearly there.' },
        { term: 'Drifting', text: 'amber. Starting to slip.' },
        { term: 'Misaligned and Neglected', text: 'red. Needs attention.' },
        { term: 'Not set up', text: 'grey. Nothing to score yet. Set it up in ATLAS.' },
      ],
    },
    {
      heading: 'Reading PANTHEON and NUMA',
      body: [
        'PANTHEON shows SHAPE, ORDER and PAN as acquired out of total. SHAPE deities cannot be acquired yet, so it stays at 0 of 5. PAN shows a dash, because the Council is a live session and not something you hold.',
        "In NUMA the dials show FLOW, LOAD and CHARGE. The colour tells you whether each one is inside your green range. You can change that range in Settings, under General, then Game.",
      ],
    },
    {
      heading: 'Moving around',
      body: ['The ▶ arrow on the right edge takes you back to the compass.'],
    },
  ],
};
